<template>
  <div ref="qrcode"></div>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
  name: "Qrcode",
  props: {
    value: String
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.createQRCode(val)
        }
      }
    }
  },
  methods: {
    /**
     * 生成二维码
     */
    createQRCode(text) {
      this.$nextTick(() => {
        this.$refs.qrcode.innerHTML = ''
        new QRCode(this.$refs.qrcode, {
          text,
          width: 304,
          height: 304
        })
      })
    }
  }
}
</script>
